<template>
  <div class="header mt-3 mt-md-0 edit-page-header">
    <div class="header-body">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="header-pretitle">
            {{ PAGE_HEADERS[page].pretitle }}
          </h6>
          <h1 class="header-title">
            {{ PAGE_HEADERS[page].title }}

            <el-popover
              v-if="page === 'REGISTER'"
              placement="right-start"
              popper-class="fifl-popper"
              :visible-arrow="false"
              trigger="hover"
            >
              <span>
                회원 등록은 본 페이지에서 회원을 등록하거나, <br>
                피플박스 앱을 통해 회원이 직접 가입하는 두 가지 <br>
                방법이 있습니다. 앱으로 회원 가입하는 방법은 <br>
                <a
                  target="_blank"
                  href="https://intercom.help/fiflbox/ko/articles/3153313-%ED%94%BC%ED%94%8C%EB%B0%95%EC%8A%A4-%EC%95%B1-%EA%B0%80%EC%9D%B4%EB%93%9C"
                >
                  이 링크
                </a>를 확인해주세요.
              </span>
              <img
                slot="reference"
                style="width: 26px;"
                src="/image/icon/help.svg"
              >
            </el-popover>
          </h1>
          <div class="header-date">
            {{ presentDate }}
          </div>
        </div>
        <div class="col-auto">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dateFns from 'date-fns';
const PAGE_HEADERS = {
  FIFL_NOTICE: {
    pretitle: '공지사항',
    title: 'FIFL 공지사항',
  },
  NOTICE: {
    pretitle: '공지',
    title: '공지 게시물',
  },
  WOD: {
    pretitle: '대시보드',
    title: '오늘의 운동',
  },
  REGISTER: {
    pretitle: '회원',
    title: '회원 등록',
  },
};

export default {
  name: 'EditPageHeader',
  props: {
    date: {},
    isDateVisible: {
      default: true,
    },
    page: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      PAGE_HEADERS,
    };
  },
  computed: {
    presentDate() {
      if (!this.isDateVisible) {
        return '';
      }

      if (this.date) {
        return dateFns.format(dateFns.parse(this.date), 'YYYY.MM.DD');
      } 
      return dateFns.format(new Date(), 'YYYY.MM.DD');
			
    },
  },
};
</script>

<style lang="scss">
.edit-page-header {
	.header-date {
		margin-top: 13px;
		font-size: 13px;
		letter-spacing: -0.8px;
		color: #9b9b9b;
	}
}
</style>
